import { Fragment, useRef } from "react";
import { Dialog, Transition } from "@headlessui/react";
import CreateEditSpeakerInputs from "../CreateEditSpeakerInputs/CreateEditSpeakerInputs";
import { CalendarIcon } from "@heroicons/react/24/outline";
import dayjs from "dayjs";

export default function Modal({
  open,
  setOpen,
  bookedDate,
  createSpeakerBooking,
  inputs,
  setInputs,
  editSpeakerBooking,
}) {
  const cancelButtonRef = useRef(null);

  return (
    <Transition.Root show={open} as={Fragment}>
      <Dialog
        as="div"
        className="relative z-10"
        initialFocus={cancelButtonRef}
        onClose={setOpen}
      >
        <Transition.Child
          as={Fragment}
          enter="ease-out duration-300"
          enterFrom="opacity-0"
          enterTo="opacity-100"
          leave="ease-in duration-200"
          leaveFrom="opacity-100"
          leaveTo="opacity-0"
        >
          <div className="fixed inset-0 bg-gray-500 bg-opacity-75 transition-opacity" />
        </Transition.Child>

        <div className="fixed inset-0 z-10 w-screen overflow-y-auto">
          <div className="flex min-h-full items-center justify-center p-4 text-center sm:items-center sm:p-0">
            <Transition.Child
              as={Fragment}
              enter="ease-out duration-300"
              enterFrom="opacity-0 translate-y-4 sm:translate-y-0 sm:scale-95"
              enterTo="opacity-100 translate-y-0 sm:scale-100"
              leave="ease-in duration-200"
              leaveFrom="opacity-100 translate-y-0 sm:scale-100"
              leaveTo="opacity-0 translate-y-4 sm:translate-y-0 sm:scale-95"
            >
              <Dialog.Panel className="relative transform overflow-hidden rounded-lg bg-white text-left shadow-xl transition-all sm:my-8 w-full sm:max-w-lg">
                <div className="bg-white px-4 pb-4 pt-3 sm:p-6 sm:pb-4">
                  <div
                    className={
                      "font-semibold justify-center w-1/2 p-2 mb-2 m-auto bg-gray-200 rounded-xl flex items-center gap-2"
                    }
                  >
                    <CalendarIcon className={"w-5 h-5"} />{" "}
                    {dayjs(bookedDate).format("DD-MM-YYYY")}
                  </div>
                  <div>
                    <CreateEditSpeakerInputs
                      bookedDate={bookedDate}
                      setOpen={setOpen}
                      cancelButtonRef={cancelButtonRef}
                      createSpeakerBooking={createSpeakerBooking}
                      inputs={inputs}
                      setInputs={setInputs}
                      editSpeakerBooking={editSpeakerBooking}
                    />
                  </div>
                </div>
              </Dialog.Panel>
            </Transition.Child>
          </div>
        </div>
      </Dialog>
    </Transition.Root>
  );
}
